import * as App from '@/types/app';
import * as Database from '@/types/database';
import { useFirestore } from '@/services';
import { defineFirebaseCollectionStoreModule } from './base-module';

const { useClientOperators } = useFirestore();
export const clientsModule = defineFirebaseCollectionStoreModule<App.Client, Database.Client>(useClientOperators);
